import {alpha, styled} from "@mui/material";
import {TreeItem2 as TreeItem, treeItemClasses} from "@mui/x-tree-view";
import type {TreeItem2Props as TreeItemProps} from "@mui/x-tree-view";
import clsx from "clsx";
import React from "react";

function CustomTreeItem(
	props: Parameters<typeof StyledItem>[0] & {
		clickable?: boolean;
		highlighted?: boolean;
	}
) {
	const {clickable, highlighted, classes, ...itemProps} = props;

	return (
		<StyledItem
			classes={{
				...classes,
				content: clsx(classes?.content, {
					clickable: clickable,
					highlighted: highlighted,
				}),
			}}
			{...itemProps}
		/>
	);
}

const StyledItem = styled(TreeItem)<TreeItemProps>(({theme}) => ({
	[`& .${treeItemClasses.content}`]: {
		cursor: "default",
		"&.clickable": {
			cursor: "pointer",
		},

		"&.highlighted": {
			background: alpha(
				theme.palette.action.hover,
				theme.palette.action.hoverOpacity
			),
		},

		paddingTop: theme.spacing(1.5),
		paddingBottom: theme.spacing(1.5),
		marginBottom: theme.spacing(0.25),
	},

	[`& .${treeItemClasses.iconContainer}`]: {
		alignSelf: "start",
	},

	[`& .${treeItemClasses.selected}`]: {
		background: alpha(
			theme.palette.secondary.main,
			theme.palette.action.selectedOpacity
		),
	},

	[`& .${treeItemClasses.selected}:hover`]: {
		background: alpha(
			theme.palette.secondary.main,
			theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity
		),
	},

	[`& .${treeItemClasses.focused}:not(.${treeItemClasses.selected}):not(:hover):not(.highlighted)`]: {
		background: "inherit",
	},

	[`& .${treeItemClasses.disabled}:hover`]: {
		background: "inherit",
	},
}));

export default CustomTreeItem;
